import type { CustomIconProps } from '../';

export const CertifiedDocumentIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2Z'
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4 10V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-8'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14 2v6h6M3 18.5V23l2-1.5L7 23v-4.5'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx={5}
      cy={16}
      r={3}
      fill={color}
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
